import React from 'react'
import { Container } from 'react-bootstrap'
import { useAuth } from '../contexts/AuthContext'
import { Link} from 'react-router-dom'
import TradingIcon from '../image/sevices/services-icons/trading.svg'
import MineriaIcon from '../image/sevices/services-icons/mineria.svg'
import EducacionIcon from '../image/sevices/services-icons/educacion-crypto.svg'
import P2pIcon from '../image/sevices/services-icons/peer-to-peer.png'
import EnviarIcon from '../image/sevices/services-icons/money.png'
import Header from './Header'
import Footer from './Footer'

export default function Dashboard() {

    const { currentUser } = useAuth()

    return (
    <>
      <div className="site-wraper overflow-hidden position-relative">
      <Header/>
          {console.log(currentUser.displayName)}
        <Container className="d-flex align-items-center justify-content-center panel">
            <div className="container px-4 py-5" id="custom-cards">
                <h2 className="pb-2 border-bottom">Servicios</h2>
                <div className="row row-cols-1 row-cols-lg-3 align-items-stretch g-4 py-4">
                    <div className="col-lg-4 col-12">
                        <div className="card card-cover overflow-hidden text-white bg-white rounded-5 shadow-sm mx-auto pb-2">
                            <Link to="/contact" className="text-decoration-none">
                            <div className="d-flex p-4 text-shadow-1 justify-content-around">
                                <h2 className="p-3 mt-2 lh-1 fw-bold services__title">Trading</h2>
                                <div className="services__icon">
                                    <img src={TradingIcon} alt="Trading Icon"/>
                                </div>
                            </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-4 col-12">
                        <div className="card card-cover overflow-hidden text-white bg-white rounded-5 shadow-sm mx-auto">
                            <Link to="/contact"  className="text-decoration-none">
                            <div className="d-flex p-4 text-shadow-1 justify-content-around">
                                <h2 className="p-3 mt-2 lh-1 fw-bold services__title">Minería <br /> bitcoin</h2>
                                <div className="services__icon">
                                    <img src={MineriaIcon} alt="Trading Icon" />
                                </div>
                            </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-4 col-12">
                        <div className="card card-cover overflow-hidden text-white bg-white rounded-5 shadow-sm mx-auto">
                            <Link to="/contact" className="text-decoration-none">
                            <div className="d-flex p-4 text-shadow-1 justify-content-around">
                                <h2 className="p-3 mt-2 lh-1 fw-bold services__title">Educación <br /> Crypto</h2>
                                <div className="services__icon">
                                    <img src={EducacionIcon} alt="Trading Icon" />
                                </div>
                            </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-4 col-12">
                        <div className="card card-cover overflow-hidden text-white bg-white rounded-5 shadow-sm mx-auto">
                            <Link to="/contact" className="text-decoration-none">
                            <div className="d-flex p-4 text-shadow-1 justify-content-around">
                                <h2 className="p-3 mt-2 lh-1 fw-bold services__title">Fondeo P2P</h2>
                                <div className="services__icon">
                                    <img src={P2pIcon} alt="Trading Icon" />
                                </div>
                            </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-4 col-12">
                        <div className="card card-cover overflow-hidden text-white bg-white rounded-5 shadow-sm mx-auto">
                            <Link to="/contact" className="text-decoration-none">
                            <div className="d-flex p-4 text-shadow-1 justify-content-around">
                                <h2 className="p-3 mt-2 lh-1 fw-bold services__title">Enviar dinero</h2>
                                <div className="services__icon">
                                    <img src={EnviarIcon} alt="Trading Icon" />
                                </div>
                            </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

        </Container>
        <Footer/>
      </div>
    </>
    )
}
